import { render, staticRenderFns } from "./OverlayCancelDelivery.vue?vue&type=template&id=450a789a&scoped=true"
import script from "./OverlayCancelDelivery.vue?vue&type=script&lang=js"
export * from "./OverlayCancelDelivery.vue?vue&type=script&lang=js"
import style0 from "./OverlayCancelDelivery.vue?vue&type=style&index=0&id=450a789a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a789a",
  null
  
)

export default component.exports